import type { CSSProperties } from "react";

type LogoVariant = "horizontal" | "short";
type LogoTheme = "auto" | "light" | "dark";

// Set v2 con variantes por tema. La tinta oscura va sobre fondos claros (tema
// claro) y la tinta blanca sobre fondos oscuros (tema oscuro). En modo "auto"
// se sirven ambas y se alternan con la clase `dark` del documento
// (tailwind darkMode: "class"); los call sites sobre un fondo fijo pueden
// forzar el tema con la prop `theme`.
const LOGOS_LIGHT: Record<LogoVariant, string> = {
  horizontal: "/brand/aequia-logo.png",
  short: "/brand/aequia-icon.png",
};
const LOGOS_DARK: Record<LogoVariant, string> = {
  horizontal: "/brand/aequia-logo-dark.png",
  short: "/brand/aequia-icon-dark.png",
};

const ASPECT_RATIO: Record<LogoVariant, number> = {
  horizontal: 3,
  short: 1,
};

interface AequiaMarkProps {
  size?: number;
  variant?: LogoVariant;
  theme?: LogoTheme;
  className?: string;
  imgClassName?: string;
}

export function AequiaMark({
  size = 32,
  variant = "horizontal",
  theme = "auto",
  className = "",
  imgClassName = "",
}: AequiaMarkProps) {
  const imageStyle: CSSProperties = {
    maxWidth: `min(${size * ASPECT_RATIO[variant]}px, 100%)`,
    maxHeight: size,
  };
  const imageClassName = `h-auto w-auto object-contain ${imgClassName}`;
  const lightSrc = LOGOS_LIGHT[variant];
  const darkSrc = LOGOS_DARK[variant];

  return (
    <span
      className={`inline-flex max-w-full items-center ${className}`}
      role="img"
      aria-label="Aequia"
    >
      {theme === "auto" ? (
        <>
          <img
            src={lightSrc}
            alt=""
            style={imageStyle}
            className={`${imageClassName} block dark:hidden`}
            draggable={false}
          />
          <img
            src={darkSrc}
            alt=""
            style={imageStyle}
            className={`${imageClassName} hidden dark:block`}
            draggable={false}
          />
        </>
      ) : (
        <img
          src={theme === "dark" ? darkSrc : lightSrc}
          alt=""
          style={imageStyle}
          className={imageClassName}
          draggable={false}
        />
      )}
    </span>
  );
}
